export function range (start, count) {
  return Array.apply(0, Array(count))
    .map((element, index) => index + start)
}

/**
 * Flatten a (possibly) multidimensional array.
 * @param  {Array} list - JavaScript array that may contain other arrays
 * @return {Array}
 */
export function flatten (arr) {
  return arr.reduce((flat, toFlatten) => {
    return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten)
  }, [])
}



// WEBPACK FOOTER //
// ./src/shared/lang.js